//  获取码配置
import {getCodeConfig} from '@/api/index'
//垛标处理
const virtualHandle = async function (el) {
    //  是否隐藏垛标得变量
    let reuslt=await getCodeConfig().then(res=>res.data).catch(error=>error)
    console.log(el.style,reuslt.data)
    if(reuslt.code!=0)return
    if(reuslt.data.is_open_virtual==0){
        el.style="display:none"
    }else{
        el.style="display:block"
    }
}
export default {
    beforeUpdate(el, binding) {
        switch (binding.arg) {
            case 'is_virtual':
                // 是否垛标功能
                virtualHandle(el)
                break;
            default:
                console.warn('未知指令类型', binding.arg)
                break
        }
    }
}